export default "__VITE_ASSET__DpsO4MR6__"